import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@shared/api/client';

export const getNewAlertsNotification = createAsyncThunk(
  'alerts/getNewAlertsNotification',
  async (accountUuid, { rejectWithValue }) => {
    try {
      const response = await client.get(
        `/accounts/${accountUuid}/alerts-aggregate`,
      );

      if (response.ok) {
        return { ok: true, data: response.data };
      }

      return rejectWithValue({
        error: response.data?.message || 'Failed to load alerts',
        status: response.status,
      });
    } catch (error) {
      return rejectWithValue({
        error: typeof error === 'string' ? error : 'Network error',
        status: null,
      });
    }
  },
);

export const getAlertTags = createAsyncThunk(
  'alerts/getAlertTags',
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.get(
        `/accounts/alerts/tags`,
      );

      if (response.ok) {
        return { ok: true, data: response.data };
      }

      return rejectWithValue({
        error: response.data?.message || 'Failed to load alert tags',
        status: response.status,
      });
    } catch (error) {
      return rejectWithValue({
        error: typeof error === 'string' ? error : 'Network error',
        status: null,
      });
    }
  },
);

export const sendViewedAlertsUuids = createAsyncThunk(
  'alerts/sendViewedAlertsUuids',
  async ({ accountUuid, viewedAlertsUuids }, { rejectWithValue }) => {
    try {
      const response = await client.post(
        `/accounts/${accountUuid}/alerts-actions`,
        {
          'action': 'view',
          'alertsUUIDs': viewedAlertsUuids,
        },
      );

      if (response.ok) {
        return { ok: true, data: response.data };
      }

      return rejectWithValue({
        error: response.data?.message || 'Failed to send viewed alerts',
        status: response.status,
      });
    } catch (error) {
      return rejectWithValue({
        error: typeof error === 'string' ? error : 'Network error',
        status: null,
      });
    }
  },
);

export const getEndpointChangeAlertAcknowledgeStatus = (accountUuid) => `/accounts/${accountUuid}/alerts-actions`;
